/**
 * The network's logo, chosen by the same rules as the network header (ic-header.component.html)
 * so every place that shows it matches the header: the main channel uses the performer info's
 * org_info.channel_logo; a sub-channel (channel_id != 0) prefers its own webpage-settings logo;
 * the organization logo is the last fallback.
 */
export function getNetworkLogo(perfomerInfoData: any, settingsData: any): string {
  const orgInfo = perfomerInfoData?.data?.Data?.[0]?.org_info;
  const channelInfo = settingsData?.channelInfo;
  const isSubChannel = channelInfo?.channel_id && channelInfo.channel_id != 0;
  if (isSubChannel && channelInfo.channel_logo) {
    return channelInfo.channel_logo;
  }
  return orgInfo?.channel_logo || orgInfo?.organization_logo || '';
}
